import React from 'react'
import { CtaArrow, TextLink } from 'newComponents'

const TextLinkArrow = ({ url, text }) => (
  <TextLink url={url} className="cta">
    {text}
    <CtaArrow />
  </TextLink>
)

export default TextLinkArrow
